import React from "react";
import { format } from "date-fns";
import { API } from "../../../config";

function OfferTable({ offers, onEdit, onDelete }) {
  return (
    <div className="w-full overflow-x-auto">
      <table className="min-w-full divide-y divide-gray-200">
        <thead className="bg-gray-50">
          <tr>
            <th
              scope="col"
              className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
            >
              Offer
            </th>
            <th
              scope="col"
              className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
            >
              Product
            </th>
            <th
              scope="col"
              className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
            >
              Discount
            </th>
            <th
              scope="col"
              className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
            >
              Validity
            </th>
            <th
              scope="col"
              className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
            >
              Status
            </th>
            <th
              scope="col"
              className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider"
            >
              Actions
            </th>
          </tr>
        </thead>
        <tbody className="bg-white divide-y divide-gray-200">
          {offers?.map((offer) => (
            <tr key={offer._id} className="hover:bg-gray-50">
              <td className="px-6 py-4 whitespace-nowrap">
                <div className="flex items-center">
                  <div className="h-10 w-10 flex-shrink-0">
                    {offer.image && (
                      <img
                        className="h-10 w-10 rounded-full object-contain shadow-xl"
                        src={`${API}/offer/image/${offer._id}`}
                        alt={offer.title}
                      />
                    )}
                  </div>
                  <div className="ml-4">
                    <div className="text-sm font-medium text-gray-900">
                      {offer.title}
                    </div>
                    <div className="text-sm text-gray-500 line-clamp-2">
                      {offer.description}
                    </div>
                  </div>
                </div>
              </td>
              <td className="px-6 py-4 whitespace-nowrap">
                <div className="text-sm text-gray-900">
                  {typeof offer?.product === "object"
                    ? offer?.product?.name
                    : "N/A"}
                </div>
                <div className="text-sm text-gray-500">
                  ID:{" "}
                  {typeof offer?.product === "object"
                    ? offer?.product?._id
                    : offer?.product}
                </div>
              </td>
              <td className="px-6 py-4 whitespace-nowrap">
                <div className="text-sm text-gray-900">
                  {offer.discountType === "percentage" ? (
                    <span className="text-green-600">
                      {offer.discountValue}%
                    </span>
                  ) : (
                    <span className="text-green-600">
                      {offer.discountValue} EGP
                    </span>
                  )}
                </div>
                {offer.maximumDiscount && (
                  <div className="text-xs text-gray-500">
                    Max: ${offer.maximumDiscount}
                  </div>
                )}
                {offer.minimumPurchase && (
                  <div className="text-xs text-gray-500">
                    Min: ${offer.minimumPurchase}
                  </div>
                )}
              </td>
              <td className="px-6 py-4 whitespace-nowrap">
                <div className="text-sm text-gray-900">
                  {format(new Date(offer.startDate), "MMM d, yyyy")}
                </div>
                <div className="text-sm text-gray-500">
                  to {format(new Date(offer.endDate), "MMM d, yyyy")}
                </div>
              </td>
              <td className="px-6 py-4 whitespace-nowrap">
                <span
                  className={`px-2 inline-flex text-xs leading-5 font-semibold rounded-full ${
                    offer.isActive
                      ? "bg-green-100 text-green-800"
                      : "bg-red-100 text-red-800"
                  }`}
                >
                  {offer.isActive ? "Active" : "Inactive"}
                </span>
              </td>
              <td className="px-6 py-4 whitespace-nowrap text-right text-sm font-medium">
                {/* <button
                  onClick={() => onEdit(offer)}
                  className="text-blue-600 hover:text-blue-900 mr-4"
                >
                  Edit
                </button> */}
                <button
                  onClick={() => onDelete(offer)}
                  className="text-red-600 hover:text-red-900"
                >
                  Delete
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

export default OfferTable;
